import { useTradeInfo } from "@/redux/selectors/tradeInfoSelector";
//import { tipRanksTickersMapping } from "../tipranks-mapping";

export const useTipRanksTicker = (): { ticker: string; tickerLabel: string } | null => {
    const { activeSymbolId, symbolsInfoById } = useTradeInfo();
    const symbolInfo = symbolsInfoById[activeSymbolId];

    const groupName = symbolInfo?.group?.name?.toLowerCase();
    const symbolId = symbolInfo?.symbol || symbolInfo?.id || null;

    const tipRanksStocks = localStorage.getItem('tip_ranks_assets_list');

    let ticker = null;
    if (groupName == 'stocks') {
        ticker = JSON.parse(tipRanksStocks)[symbolId];
    }

    if (!ticker) {
        return {
            ticker: null,
            tickerLabel: null,
        };
    }

    return {
        ticker,
        tickerLabel: symbolInfo?.ex?.displayName || symbolInfo?.symbol || symbolInfo?.id || "",
    };
};
